import * as Realm from 'realm-web';
import { appConfig } from '../../../configs/appConfig';

export const oid = Realm.BSON.ObjectId;
export const atlasApp = new Realm.App({ id: appConfig.appId });

